import * as Yup from 'yup';

export default Yup.object().shape({
  id: Yup.number(),
  name: Yup.string(50).required('Status Name is required').max(50, 'Please use less than 50 characters'),
  colorCode: Yup.string().required(),
  requiresComment: Yup.boolean().nullable(),
});